/**
 * @license bippy
 *
 * Copyright (c) Aiden Bai
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { safelyInstallRDTHook$1 as safelyInstallRDTHook } from "./rdt-hook-D8LwQB-4.js";

//#region src/index.ts
safelyInstallRDTHook();

//#endregion